import { render, staticRenderFns } from "./xyjck.vue?vue&type=template&id=8222c948&scoped=true"
import script from "./xyjck.vue?vue&type=script&lang=js"
export * from "./xyjck.vue?vue&type=script&lang=js"
import style0 from "./xyjck.vue?vue&type=style&index=0&id=8222c948&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8222c948",
  null
  
)

export default component.exports